import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import {
  Ch_confirmBetterDocRejectionInput,
  chConfirmBetterDocRejectionMutation,
} from "@/modules/patients/services/ch/__generated__/chConfirmBetterDocRejectionMutation.graphql"
import { chConfirmBetterDocRejection } from "@/modules/patients/services/ch/chConfirmBetterDocRejectionMutation"
import {
  De_confirmBetterDocRejectionInput,
  deConfirmBetterDocRejectionMutation,
} from "@/modules/patients/services/de/__generated__/deConfirmBetterDocRejectionMutation.graphql"
import { deConfirmBetterDocRejection } from "@/modules/patients/services/de/deConfirmBetterDocRejectionMutation"
import { Country } from "@/types/__generated__/union-types"

type ConfirmBetterDocRejectionInput = Ch_confirmBetterDocRejectionInput & De_confirmBetterDocRejectionInput

type UseConfirmBetterDocRejectionMutationResult = {
  confirmBetterDocRejection: (input: ConfirmBetterDocRejectionInput, handleComplete: VoidFunction) => void
  isConfirmingBetterDocRejection: boolean
}

export function useConfirmBetterDocRejectionMutation(country: Country): UseConfirmBetterDocRejectionMutationResult {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chConfirmBetterDocRejection
      case "DE":
        return deConfirmBetterDocRejection
    }
  })()

  const [commit, isConfirmingBetterDocRejection] = useMutationWithErrorToast<
    chConfirmBetterDocRejectionMutation & deConfirmBetterDocRejectionMutation
  >(mutation)

  const confirmBetterDocRejection = useCallback(
    (input: ConfirmBetterDocRejectionInput, handleComplete: VoidFunction) => {
      commit({
        variables: { input },
        onCompleted: () => handleComplete(),
      })
    },
    [commit],
  )

  return { confirmBetterDocRejection, isConfirmingBetterDocRejection }
}
